import axios from 'axios';
import { getBaseUrl } from './config';

const instance = axios.create({
  baseURL: getBaseUrl(),
  withCredentials: true,
});

export default instance;
